import React, { createContext, useEffect, useState } from 'react'

const PanelStyleContext = createContext(null)

const PanelStyleContextProvider = ({
    panelClassConfig,
    componentWidth,
    children,
}) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const [width, setWidth] = useState(componentWidth)

    useEffect(() => {
        if (isExpanded) {
            setWidth('full')
            panelClassConfig.panelClassName = `column is-full`
        } else {
            setWidth(panelClassConfig.originalWidth)
            panelClassConfig.panelClassName = `column`
        }
    }, [isExpanded, panelClassConfig])

    return (
        <PanelStyleContext.Provider
            value={{
                isExpandible: true, // by default all panelClassConfig will have isExpandible true, can be defined false otherwise --- NOT USED CURRENTLY
                ...panelClassConfig,
                isExpanded,
                setIsExpanded,
                width,
                setWidth,
            }}
        >
            {children}
        </PanelStyleContext.Provider>
    )
}

export { PanelStyleContext }
export default PanelStyleContextProvider
